// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { DocumentCode2, OceanProtocol, Level, ShieldCross, InfoCircle, I24Support, Driving } from 'iconsax-react';

// icons
const icons = {
  samplePage: DocumentCode2,
  menuLevel: OceanProtocol,
  menuLevelSubtitle: Level,
  disabledMenu: ShieldCross,
  chipMenu: InfoCircle,
  documentation: I24Support,
  roadmap: Driving
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const support = {
  id: 'other',
  title: <FormattedMessage id="others" />,
  type: 'group',
  children: [
    {
      id: 'dashboard-page',
      title: <FormattedMessage id="Dashboard Page" />,
      type: 'item',
      url: '/dashboard-page',
      icon: icons.samplePage
    },
    // manage admins
     {
      id: 'manage-admin',
      title: <FormattedMessage id="Manage Admin" />,
      type: 'collapse',
      icon: icons.menuLevel,
      children: [
      {
        id: 'create-admin',
        title: (
          <>
            <FormattedMessage id="Create Admin" />
          </>
        ),
        type: 'item',
        url: '/create-admin'
      },
      {
        id: 'admin-list',
        title: (
          <>
            <FormattedMessage id="Admin List" />
          </>
        ),
        type: 'item',
        url: '/manage-admin'
      },
    ]
    },
    // manage Users
    {
      id: 'manage-users',
      title: <FormattedMessage id="Manage Users" />,
      type: 'collapse',
      icon: icons.menuLevel,
      children: [
      {
        id: 'create-user',
        title: (
          <>
            <FormattedMessage id="Create User" />
          </>
        ),
        type: 'item',
        url: '/create-user'
      },
      {
        id: 'user-list',
        title: (
          <>
            <FormattedMessage id="Users List" />
          </>
        ),
        type: 'item',
        url: '/manage-users'
      },
    ]
    },
     // Manage Category
     {
      id: 'manage-category',
      title: <FormattedMessage id="Manage Category" />,
      type: 'collapse',
      icon: icons.menuLevel,
      children: [
      {
        id: 'create-category',
        title: (
          <>
            <FormattedMessage id="Create Category" />
          </>
        ),
        type: 'item',
        url: '/create-category'
      },
      {
        id: 'category-list',
        title: (
          <>
            <FormattedMessage id="Category List" />
          </>
        ),
        type: 'item',
        url: '/manage-category'
      },
    ]
    },
    // Manage Reference
    {
      id: 'manage-reference',
      title: <FormattedMessage id="Manage Reference" />,
      type: 'collapse',
      icon: icons.menuLevel,
      children: [
      {
        id: 'create-reference',
        title: (
          <>
            <FormattedMessage id="Create Reference" />
          </>
        ),
        type: 'item',
        url: '/create-reference'
      },
      {
        id: 'reference-list',
        title: (
          <>
            <FormattedMessage id="Reference List" />
          </>
        ),
        type: 'item',
        url: '/manage-reference'
      },
    ]
    },
   
  
   
  ]
};

export default support;
